/*  ========================================================================
    # Scripts - Scrollable Content
    ========================================================================  */

/**
 * Script that controls content display
 */

const ScrollableContent = {
  cfg: {
    scrollableContentEntry: document.querySelectorAll('.s-scrollable-content__entry'),
    scrollableContent: document.querySelectorAll('.s-scrollable-content__content'),
    states: {
      activeContent: 's-scrollable-content__entry--active'
    },
    activeEntry: '0'
  },

  /**
   * Handle scrollable content
   */
  handleScrollableContent() {
    document.addEventListener(
      'scroll',
      e => {
        const viewportHeight = window.innerHeight;

        let bestIndex = null;
        let bestRatio = 0;

        this.cfg.scrollableContent.forEach((content, index) => {
          const rect = content.getBoundingClientRect();
          const elemHeight = rect.height || 1;

          const intersectionTop = Math.max(rect.top, 0);
          const intersectionBottom = Math.min(rect.bottom, viewportHeight);
          const intersectionHeight = Math.max(0, intersectionBottom - intersectionTop);

          const visibleRatio = Math.min(1, Math.max(0, intersectionHeight / elemHeight));

          if (visibleRatio >= 0.5 && visibleRatio > bestRatio) {
            bestRatio = visibleRatio;
            bestIndex = index;
          }
        });

        if (bestIndex !== null) {
          this.cfg.activeEntry = bestIndex.toString();
        }

        this.cfg.scrollableContent.forEach(scrollEntry => {
          const target = Array.from(this.cfg.scrollableContentEntry).find(
            entry => entry.dataset.scrollTarget === scrollEntry.dataset.scrollTrigger
          );

          if (target.dataset.scrollTarget === this.cfg.activeEntry) {
            target.classList.add(this.cfg.states.activeContent);
          } else {
            target.classList.remove(this.cfg.states.activeContent);
          }
        });
      },
      { passive: true }
    );
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.scrollableContent) {
      this.handleScrollableContent();
    }
  }
};

export default ScrollableContent;
